module.exports = __webpack_public_path__ + "static/media/no_record_found.d141319b.png";